import React from 'react';
import { Route } from 'react-router-dom';
import { OrdersLoadingDialog } from './orders-loading-dialog/OrdersLoadingDialog';
import { OrderDeleteDialog } from './order-delete-dialog/OrderDeleteDialog';
import { OrdersUIProvider } from './OrdersUIContext';
import OrdersCard from './OrdersCard';

const OrdersPage = ({ history }) => {
  const OrdersUIEvents = {
    openCreateOrderDialog: () => {
      history.push('/orders/new');
    },
    openViewOrderDialog: (id) => {
      history.push(`/orders/${id}/edit`);
    },
    openDeleteOrderDialog: (id) => {
      history.push(`/orders/${id}/delete`);
    },
  };

  return (
    <OrdersUIProvider OrdersUIEvents={OrdersUIEvents}>
      <OrdersLoadingDialog />
      <Route path='/orders/:id/delete'>
        {({ history, match }) => (
          <OrderDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push('/orders');
            }}
          />
        )}
      </Route>
      <OrdersCard props />
    </OrdersUIProvider>
  );
};

export default OrdersPage;
